import { useEffect, useState } from 'react';
import { getMActiveId } from '../../store/localstorage';
import { getItemFromMisc, getMe } from '../../store/idbHandler';
import { BizSettings } from '../../api/fetchMyGenie';
import { track } from '../../tracking';
import { HUB, LOGIN } from '../../api/constants';
import { sparklesIcon } from './Icons';
import { getMedantaBizId } from '../../store/actions/app';

export const LS_NEW_SIGN_IN_STRIP = 'newSignInStrip';

const NewSignInStrip = () => {
    const [canShowNewSignInStrip, setCanShowNewSignInStrip] = useState(false);

    useEffect(() => {
        getShowNewSignInStrip();
    }, []);

    const getShowNewSignInStrip = async () => {
        const myId = getMActiveId();
        if (!myId) {
            return true;
        }
        const bid = getMe()?.user['b-id'];
        const medantaBizId = getMedantaBizId();
        const blackListedBids = [...medantaBizId, '74117920305567'];
        const isBlackListedBusiness = blackListedBids.includes(bid ?? '');
        const isClosed = localStorage.getItem(LS_NEW_SIGN_IN_STRIP) === 'false';
        if (isBlackListedBusiness || isClosed) {
            return;
        }
        const { showNewSignInStrip = true } = (await getItemFromMisc<BizSettings>(
            myId,
            'bizSettings',
        )) || { showNewSignInStrip: true };
        setCanShowNewSignInStrip(showNewSignInStrip);
    };

    const onAddNewSignIn = () => {
        window.open(
            `${LOGIN}/workspace/sign-in/?product_type=emr&add_identity=true&next=${HUB}/account/alternate-login-success/`,
        );
        track('ADD_NEW_SIGN_IN_STRIP');
    };

    const onClose = () => {
        localStorage.setItem(LS_NEW_SIGN_IN_STRIP, 'false');
        setCanShowNewSignInStrip(false);
        track('ADD_NEW_SIGN_IN_STRIP_CLOSE');
    };

    if (!canShowNewSignInStrip) {
        return null;
    }

    return (
        <div className="mt-8 mx-8">
            <div
                className="relative flex items-center justify-between mb-16 w-full px-16 py-7 rounded-8"
                style={{
                    background: 'linear-gradient(98deg, #215FFF -9.13%, #143999 127.71%)',
                }}
            >
                <div
                    onClick={onClose}
                    className="absolute py-4 px-4 bg-white -top-10 -right-8 rounded-full border border-darwin-neutral-1000 cursor-pointer"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        className="w-12 h-12 fill-darwin-neutral-1000"
                    >
                        <path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path>
                    </svg>
                </div>
                <div className="flex items-center gap-8">
                    <span className="m-4">{sparklesIcon()}</span>
                    <p className="text-white text-14 font-400 text-white font-700">
                        Faster & safer sign-in method available!
                    </p>
                </div>
                <div>
                    <button
                        className="bg-white text-darwin-accent-bright-blue-800 px-8 py-4 rounded-4 text-13 font-700"
                        onClick={onAddNewSignIn}
                    >
                        Avail now
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NewSignInStrip;
